export const environment = {
    production: false,
    apiHost: '',
    marketplaceHost: '/graphql',
    hydraV1: 'https://hydra-02.rebtel.com',
    key: 'dev',
    providerPortal: {
        adyen: {
            transaction: 'https://ca-test.adyen.com/ca/ca/accounts/showTx.shtml?pspReference={pspReference}&txType=Payment'
        }
    }
};